import React, { Component } from "react";
import Helping from '../../helpers/Helping';
import Service from '../../helpers/service';
import Notification from "../layout/Notification";
import Pagination from "react-js-pagination";
import { MESSAGE, ROLE, ROUTE_ACCESS, NODE_ENV } from '../../config/index';
import { API_URL } from '../../config/urls';
import { connect } from 'react-redux';
import { getAll, update, setItemError } from '../../services/item.service';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import { validateField, setErrorFields } from '../../helpers/validationHelpers';
import Filter from "../layout/Filter";
import MoneyField from '../fields/moneyField';
import LoadingButton from "../fields/LoadingButton";
import { trackPromise } from "react-promise-tracker";
import CreateNFT from "./Create";
import routes from "../../config/routes";

const { NOT_FOUND, EMPTY, MINT, GIFTED, ENABLE, DISABLE } = MESSAGE;
class List extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            url: API_URL.ADMIN_TRADING_API + 'items',
            count: '',
            routeName: '',
            username: '',
            code: '',
            name: '',
            number_minted: '',
            item_id: '',
            error_message: '',
            error_type: '',
            isLoading: true,
            blockchain: '',
            total: 0,
            activePage: 1,
            limit: 10,
            search: props.search,
            sorting: 'id',
            sort_type: 'DESC',
            is_order: false,
            edit_id: "",
            btnIsDisable: false,
            slideModal: false
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.pageRefreshFunction = this.pageRefreshFunction.bind(this);
        this.closeEditModal = this.closeEditModal.bind(this);
        this.sortBy = this.sortBy.bind(this);
    }

    setErrorOnApiCall = () => {
        setItemError(res => this.setState({ ...res }));
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    componentDidMount() {
        const { pathname } = this.props.location;
        this.props.addCurrentRoute(this.props.profile, pathname);
        this.setErrorOnApiCall();

        this.setState({
            routeName: pathname
        });

        if (this.props.isLoading == true && this.props.items.length < 1) {
            this.getItems();
        }
    }

    getItems = () => {
        let search = this.state.search;

        this.props.getAll(
            this.state.activePage,
            this.state.limit,
            search.trim(),
            this.state.sorting,
            this.state.sort_type
        );
    }

    pageRefreshFunction(e) {
        e.preventDefault();

        this.setState({
            search: "",
            activePage: 1,
            error_message: "",
            error_type: ""
        },
            () => this.getItems());
    }

    handlePageChange(pageNumber) {
        if (this.state.activePage === pageNumber) {
            return false;
        }

        this.setState({
            activePage: pageNumber,
            isLoading: true
        }, () => {
            this.getItems();
        });
    }

    handleLimitChange(itemsLimit) {
        if (this.state.limit === itemsLimit) {
            return false;
        }
        this.setState({
            limit: itemsLimit,
            activePage: 1,
            isLoading: true
        }, () => {
            this.getItems();
        });
    }

    handleSearchChange(e) {
        let $this = this,
            searchValue = e.target.value.replace(/^\s+/g, '');

        if (this.state.search !== searchValue) {
            this.setState({
                search: searchValue,
                activePage: 1
            }, () => {
                if (searchValue.length > 0) {
                    $this.getItems();
                }

                if (searchValue.length === 0) {
                    $this.getItems();
                }
            });
        }
    }

    handleInputChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "code") this.setState({ ...await validateField("string", name, value, "", 1) });
        if (name === "username") this.setState({ ...await validateField("string", name, value, "", 1) });
        if (name === "number_minted") this.setState({ ...await validateField('numeric', name, value, '', 1) });
        if (name === "blockchain") this.setState({ ...await validateField("string", name, value, "", 1) });
    }

    checkMintEmptyFields = () => {
        const { number_minted, blockchain } = this.state;
        let formHasError = false;

        if (Number(number_minted) < 1) {
            let errorObject = setErrorFields("number_minted", Helping.getMessageString(EMPTY, "Number Minted"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (blockchain.length < 1) {
            let errorObject = setErrorFields("blockchain", Helping.getMessageString(EMPTY, "Blockchain"));
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    checkGiftEmptyFields = () => {
        const { username, code } = this.state;
        let formHasError = false;

        if (username.length < 1) {
            let errorObject = setErrorFields("username", Helping.getMessageString(EMPTY, "username"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (code.length < 1) {
            let errorObject = setErrorFields("code", Helping.getMessageString(EMPTY, "code"));
            this.setState(errorObject);
            formHasError = true;
        }

        return formHasError;
    }

    openConfirmPopup = (e) => {
        e.preventDefault();

        const formHasError = this.checkMintEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return true;
        }

        window.$('#confirmNFTCopy').modal('show');
    }

    submitMintModal = (e) => {
        e.preventDefault();
        const { item_id, number_minted, blockchain } = this.state;

        this.setState({
            btnIsDisable: true
        })

        Service.postCall(API_URL.ADMIN_TRADING_API + routes.CREATE_NFT_COPIES, {
            item_id: Number(item_id),
            number_minted: Number(number_minted),
            which_bc: blockchain
        })
            .then(response => {
                this.setState(
                    {
                        item_id: '',
                        number_minted: '',
                        error_message: Helping.getMessageString(MINT, `${blockchain} nft copies`),
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.closeMintModal(); this.scrollToTop(); }
                );
            }).catch(error => {
                console.log({ error });

                if (error.response) {
                    Helping.redirectToLogin(error);
                    return this.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        btnIsDisable: false
                    }, () => { this.closeMintModal(); this.scrollToTop(); });
                }
                return this.setState({
                    isLoading: false,
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, "creating nft copies")
                }, () => { this.closeMintModal(); this.scrollToTop(); })
            });
    }

    submitGiftModal = (e) => {
        e.preventDefault();

        const formHasError = this.checkGiftEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return true;
        }

        this.setState({
            btnIsDisable: true
        })

        Service.postCall(API_URL.ADMIN_TRADING_API + routes.GIFT_AVATAR, {
            username: this.state.username,
            code: this.state.code
        }).then(response => {
            this.setState(
                {
                    error_message: Helping.getMessageString(GIFTED, "avatar"),
                    error_type: "success",
                    username: "",
                    code: "",
                    btnIsDisable: false
                }, () => { this.closeGiftModal(); this.scrollToTop(); }
            );
        }).catch(error => {
            console.log({ error });

            if (error.response) {
                Helping.redirectToLogin(error);
                return this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => { this.closeGiftModal(); this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "gifting avatar")
            }, () => { this.closeGiftModal(); this.scrollToTop(); })
        });
    }

    openCreateModal = () => {
        this.setState({ edit_id: '', slideModal: true }, () => window.openSlideModal())
    }

    openEditModal = (e, object) => {
        this.setState({ edit_id: object.id, slideModal: true }, () => window.openSlideModal())
    }

    closeEditModal() {
        this.setState({
            edit_id: '',
            slideModal: false
        },
            () => window.closeSlideModal())
    }

    closeMintModal = () => {
        window.$('#confirmNFTCopy').modal('hide');
        window.$('#createNewNFTCopy').modal('hide');

        this.setState({
            number_minted: "",
            blockchain: "",
            name: "",
            error_number_minted_message: "",
            error_blockchain_message: ""
        })
    }

    closeGiftModal = () => {
        window.$('#giftNFT').modal('hide');

        this.setState({
            code: "",
            username: "",
            error_code_message: "",
            error_username_message: ""
        })
    }

    sortBy(key) {
        let $this = this;
        let sortType = this.state.sort_type;

        if (this.state.sort_type === 'DESC') {
            sortType = 'ASC';
        }

        if (this.state.sort_type === 'ASC') {
            sortType = 'DESC';
        }

        this.setState({
            sorting: key,
            activePage: 1,
            is_order: true,
            sort_type: sortType
        }, () => {
            $this.getItems();
        });
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    changeNftStatus = (id, active) => {
        let errorMessage = active ? Helping.getMessageString(ENABLE, `NFT`) : Helping.getMessageString(DISABLE, `NFT`),
            data = {
                is_active: active
            }

        trackPromise(
            Service.putCall(this.state.url + "/" + id, data, Helping.getConfig())
                .then(response => {
                    this.props.update(response.data.payload);
                    this.setState(
                        {
                            error_message: errorMessage,
                            error_type: "success",
                        }, () => { this.scrollToTop(); }
                    );
                })

                .catch(error => {
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: "danger"
                        }, () => { this.scrollToTop(); }
                        )
                    }

                    return this.setState({
                        isLoading: false,
                        ...Helping.setNetworkRequestError(error, "updating nft")
                    }, () => { this.scrollToTop(); })
                })
        )
    }

    filteredResults = (e) => {
        e.preventDefault();
        this.setState({
            activePage: 1
        }, () => this.getItems())
    }

    render() {
        let role_access = {}, isAdmin = false;
        const data = {
            inputs: [],
            reset: this.pageRefreshFunction,
            getResults: this.filteredResults
        }

        if (Object.keys(this.props.profile).length > 0) {
            role_access = JSON.parse(this.props.profile.role_access);
            isAdmin = role_access.role === ROLE.ADMIN.toLowerCase();
        }
        let writeAccess = isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.NFT.toLowerCase()].write);

        return (
            <>
                {(writeAccess && this.state.slideModal) &&
                    <CreateNFT id={this.state.edit_id} closeEditModal={this.closeEditModal} />
                }
                <div class="content nfts-list">
                    <div class="top-header">
                        <div class="header-title">
                            <h2 class="title">NFTs List</h2>
                            <span class="title-caption">You have total {this.props.total} nfts.</span>

                            {/*  SEARCH BAR  */}
                            <form class="listing-search-form" onSubmit={(e) => e.preventDefault()}>
                                <span class="search-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999">
                                        <path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)" />
                                    </svg>
                                </span>
                                <input class="form-control" type="search" placeholder="Search in Nfts" aria-label="Search" value={this.state.search} onChange={(e) => this.handleSearchChange(e)} />
                            </form>
                            {/*  SEARCH BAR END  */}
                        </div>

                        <div class="header-btn">
                            <button class="custom-btn icon-btn dark-btn sm-btn" onClick={this.pageRefreshFunction}>
                                <svg id="refresh" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                    <path id="Path_449" data-name="Path 449" d="M313.164,391.557c-.048-.293-.092-.582-.142-.871a1.127,1.127,0,0,1,.858-1.384,1.064,1.064,0,0,1,1.23.963q.326,1.894.628,3.794a1.1,1.1,0,0,1-.933,1.327l-3.615.643a1.065,1.065,0,0,1-1.262-.888,1.1,1.1,0,0,1,.854-1.288c.438-.095.882-.163,1.378-.252-.108-.068-.173-.113-.242-.151a6.869,6.869,0,0,0-10.015,5.356,7.187,7.187,0,0,0,5.554,8.138,6.961,6.961,0,0,0,8.137-5.977,1.081,1.081,0,0,1,1-.984,1.024,1.024,0,0,1,1.063.8,2.485,2.485,0,0,1-.027.9,9.223,9.223,0,0,1-7.31,7.461,9.074,9.074,0,0,1-10.447-7.421,9.412,9.412,0,0,1,7.2-11.144,8.62,8.62,0,0,1,5.859.9c.053.028.1.056.158.082A.241.241,0,0,0,313.164,391.557Z" transform="translate(-299.689 -389.283)" />
                                </svg>
                                <span class="txt-btn">Refresh</span>
                            </button>

                            {writeAccess && (
                                <>
                                    <button class="custom-btn icon-btn dark-btn sm-btn" data-toggle="modal"
                                        data-target="#giftNFT">Gift NFT
                                    </button>
                                    <button class="custom-btn gradiant-btn sm-btn" id="addButton" onClick={() => this.openCreateModal()}>Add New NFT</button>
                                </>
                            )}
                        </div>
                    </div>

                    <div class="main-content">

                        {this.state.error_message &&
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                                callback={this.removeNetworkError}
                            />
                        }
                        <div class="listing-tbl table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('id')}>
                                            ID
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('name')}>
                                            Name
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'name' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'name' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="text-center" scope="col">Image</th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('code')}>
                                            Code
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'code' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'code' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('amount')}>
                                            Amount
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'amount' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'amount' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('generation')}>
                                            Generation
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'generation' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'generation' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th scope="col">Brand</th>
                                        {/*<th scope="col">IP</th>*/}
                                        <th class="tbl-sorting text-center" scope="col" onClick={() => this.sortBy('number_minted')}>
                                            Number Minted
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'number_minted' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'number_minted' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('created_at')}>
                                            Date Created
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'created_at' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'created_at' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        {writeAccess &&
                                            <th scope="col">Actions</th>
                                        }
                                    </tr>
                                </thead>

                                {(this.props.total > 0 && !this.props.isLoading) && (
                                    <tbody>
                                        {this.props.items.map((item, i) => (
                                            <tr key={i}>
                                                <td scope="row">{item.id}</td>
                                                <td class="truncate">{item.name}</td>
                                                <td>
                                                    <div class="newsCoverImg">
                                                        <img src={item.thumbnail_url} alt="" class="img-fluid" />
                                                    </div>
                                                </td>
                                                <td>{item.code}</td>
                                                <td>{item.amount ? <MoneyField value={item.amount} /> : 0}</td>
                                                <td><div>{item.generation ? item.generation : null}</div></td>
                                                <td>{item.brand_name}</td>
                                                {/*<td>{item.ip ? item.ip.name : null}</td>*/}
                                                <td class="text-center">{Number(item.number_minted)}</td>
                                                <td>{Helping.convertTimeToHumanReadableFormat(item.created_at)}</td>
                                                {writeAccess && (
                                                    <td>
                                                        <div className="action-links">
                                                            <div class="form-switch icon" title="Enable/Disable NFT">
                                                                <input type="checkbox" class="check-form-input" id={`activeNFT${i}`} checked={item.isActive} onChange={(e) => this.changeNftStatus(item.id, e.target.checked)} />
                                                                <label for={`activeNFT${i}`}></label>
                                                            </div>
                                                            <button class="icon copy" title="Create new NFT" data-toggle="modal" data-target="#createNewNFTCopy" onClick={() => this.setState({ item_id: item.id, name: item.name })}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                                                    <path id="category" d="M10,2A7.4,7.4,0,0,0,3,8.969v5.687A3.457,3.457,0,0,0,6.562,18H7v.656A3.457,3.457,0,0,0,10.562,22h6.876A3.457,3.457,0,0,0,21,18.656V9.344A3.457,3.457,0,0,0,17.438,6H17V5.344A3.457,3.457,0,0,0,13.438,2Zm1,2h2.438A1.468,1.468,0,0,1,15,5.344v9.312A1.468,1.468,0,0,1,13.438,16H6.562A1.468,1.468,0,0,1,5,14.656V10H7.438A3.458,3.458,0,0,0,11,6.656ZM9,4.137,9,6.656A1.468,1.468,0,0,1,7.438,8l-2.3-.007A5.72,5.72,0,0,1,9,4.137ZM17,8h.438A1.468,1.468,0,0,1,19,9.344v9.312A1.468,1.468,0,0,1,17.438,20H10.562A1.468,1.468,0,0,1,9,18.656V18h4.438A3.457,3.457,0,0,0,17,14.656Z" transform="translate(-3 -2)" />
                                                                </svg>
                                                            </button>
                                                            <button class="icon edit" title="Edit NFT" data-toggle="modal" data-target="#editUserModal" onClick={(e) => this.openEditModal(e, item)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                    <path id="edit" d="M17,2a1.02,1.02,0,0,0-.719.281l-2,2-8,8A1.02,1.02,0,0,0,6,13v4a1,1,0,0,0,1,1h4a1.02,1.02,0,0,0,.719-.281l8-8,2-2A1.02,1.02,0,0,0,22,7a4.944,4.944,0,0,0-1.281-3.687A4.849,4.849,0,0,0,17,2Zm.375,2.063a2.753,2.753,0,0,1,1.906.625,2.92,2.92,0,0,1,.656,1.937L19,7.563,16.437,5ZM15,6.438,17.562,9l-7,7H8V13.438ZM10,4a1,1,0,0,1,0,2H6A2,2,0,0,0,4,8V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V14a1,1,0,0,1,2,0v4a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4Z" transform="translate(-2 -2)" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                            </table>
                        </div>

                        {this.props.total > 0 && (
                            <div class="table-bottom">
                                <div class="dataTables_length">
                                    <label>Show
                                        <select
                                            name="userDataTable_length"
                                            value={this.props.limit}
                                            onChange={(e) => this.handleLimitChange(e.target.value)}
                                        >
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select> of {this.props.total}</label>
                                </div>
                                <Pagination
                                    // hideFirstLastPages
                                    activePage={this.props.page}
                                    itemsCountPerPage={this.props.limit}
                                    totalItemsCount={this.props.total}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange}
                                    itemClass='page-item'
                                    linkClass='page-link'
                                    prevPageText='Pre'
                                    nextPageText='Next'
                                    firstPageText='First'
                                    lastPageText='Last'
                                    innerClass="dataTables_paginate"
                                    linkClass="paginate_button"
                                    activeLinkClass="paginate_button current"
                                    disabledClass="paginate_button disabled"
                                />
                            </div>
                        )}

                        {(this.props.total < 1 && !this.props.isLoading) && (
                            <div className='table-responsive'>
                                <Notification
                                    type='danger'
                                    message={Helping.getMessageString(
                                        NOT_FOUND,
                                        'NFTs '
                                    )}
                                    callback={this.removeNetworkError}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {/* ----- Gift NFT Modal ----- */}
                <div class="actionModal modal fade" id="giftNFT" tabindex="-1" role="dialog" aria-labelledby="giftNFT" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">Gift NFT</h5>
                            </div>

                            <div class="modal-body">
                                <div class="form-group">
                                    <label for="username">Username: </label>
                                    <input type="text" name="username" class={`form-control ${this.state.error_username_message ? 'error-input' : ''}`} value={this.state.username} id="username" onChange={(e) => this.handleInputChange(e)} />
                                    <span className="error-msg">{this.state.error_username_message}</span>
                                </div>
                                <div class="form-group mb-0">
                                    <label for="nftCode">Code: </label>
                                    <input type="text" name="code" class={`form-control ${this.state.error_code_message ? 'error-input' : ''}`} value={this.state.code} id="nftCode" onChange={(e) => this.handleInputChange(e)} />
                                    <span className="error-msg">{this.state.error_code_message}</span>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal" onClick={this.closeGiftModal}>Close</button>
                                {this.state.btnIsDisable ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.submitGiftModal(e)}>{this.state.btnIsDisable ? "Loading..." : "Submit"}</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* ----- Create NFT Copy Modal ----- */}
                <div class="actionModal modal fade" id="createNewNFTCopy" tabindex="-1" role="dialog" aria-labelledby="createNewNFTCopy" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">Create NFT Copy of {this.state.name}</h5>
                            </div>

                            <div class="modal-body">
                                <div class="form-group">
                                    <label for="numberMint">Number Minted: </label>
                                    <input type="text" name="number_minted" class={`form-control ${this.state.error_number_minted_message ? 'error-input' : ''}`} value={this.state.number_minted} id="numberMint" onChange={(e) => this.handleInputChange(e)} />
                                    <span className="error-msg">{this.state.error_number_minted_message}</span>
                                </div>
                                <div class="form-group mb-0">
                                    <label for="BlockchainNo">Blockchain: </label>
                                    <select class={`form-select ${this.state.error_blockchain_message ? 'error-input' : ''}`} name="blockchain" aria-label="Blockchain select example"
                                        id="BlockchainNo" value={this.state.blockchain} onChange={(e) => this.handleInputChange(e)}>
                                        <option value="" selected>Select Blockchain...</option>
                                        <option value="CARDANO">CARDANO</option>
                                        <option value="MATIC">MATIC</option>
                                        {NODE_ENV === 'DEV' &&
                                            <option value="TEZOS">TEZOS</option>
                                        }
                                        <option value="ETH">ETH</option>
                                    </select>
                                    <span className="error-msg">{this.state.error_blockchain_message}</span>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal" onClick={this.closeMintModal}>Close</button>
                                <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={this.openConfirmPopup}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Confirmation NFT Copies */}
                <div class="actionModal modal fade" id="confirmNFTCopy" tabindex="-1" role="dialog" aria-labelledby="confirmNFTCopy" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Confirm New NFT Copy </h5>
                            </div>

                            <div class="modal-body">
                                <p class="modal-msg">You are about to confirm the NFT copy.</p>
                                <p><strong>Do you want to proceed?</strong></p>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                                {this.state.btnIsDisable ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.submitMintModal(e)}>{this.state.btnIsDisable ? "Loading..." : "Confirm"}</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
        items: state.items,
        total: state.itemMeta.total,
        limit: state.itemMeta.limit,
        isLoading: state.itemMeta.isLoading,
        page: state.itemMeta.page,
        search: state.itemMeta.search,
        no_Of_pages: state.itemMeta.no_Of_pages
    };
};

const mapDispatchToProps = {
    getAll,
    update,
    addCurrentRoute
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(List);